import { DocumentNode, gql } from '@apollo/client'

export const UPDATE_DAYCARE_CHILD_MEAL: DocumentNode = gql`
    mutation updateDaycareChildMeal(
        $daycareId: Int!
        $childId: Int!
        $menuIds: [Int]
        $textureIds: [Int]
        $habitIds: [Int]
    ) {
        updateDaycareChildMeal(
            daycareId: $daycareId
            childId: $childId
            menuIds: $menuIds
            textureIds: $textureIds
            habitIds: $habitIds
        )
    }
`

export const UPDATE_DAYCARE_CHILDREN_MEAL: DocumentNode = gql`
    mutation updateDaycareChildrenMeal(
        $daycareId: Int!
        $childIds: [Int!]!
        $menuIds: [Int]
        $textureIds: [Int]
        $habitIds: [Int]
    ) {
        updateDaycareChildrenMeal(
            daycareId: $daycareId
            childIds: $childIds
            menuIds: $menuIds
            textureIds: $textureIds
            habitIds: $habitIds
        )
    }
`
